import { trans } from "../../functions"
import noUiSlider from "nouislider"

export default {
  props: [
    "initialQuery",
    "initialBrandName",
    "initialBrandBanner",
    "initialBrandSlug",
    "initialCategoryName",
    "initialCategory",
    "initialCategoryBanner",
    "initialCategorySlug",
    "initialTagName",
    "initialTagSlug",
    "initialAttribute",
    "initialNewAttribute",
    "maxPrice",
    "maxYear",
    "minYear",
    "initialSort",
    "initialPerPage",
    "initialPage",
    "initialViewMode",
    "isDailyDealToday",
    "isRareFind",
    "isTap",
    "isAdmin"
  ],
  data() {
    return {
      activeFilters: [],
      countries: [],
      keyword: null,
      fetchingProducts: false,
      products: { data: [] },
      attributeFilters: [],
      brandBanner: this.initialBrandBanner,
      categoryName: this.initialCategoryName,
      category: this.initialCategory,
      categoryBanner: this.initialCategoryBanner,
      viewMode: this.initialViewMode,
      queryParams: {
        query: this.initialQuery,
        brand: this.initialBrandSlug,
        category: this.initialCategorySlug,
        tag: this.initialTagSlug,
        attribute: this.initialAttribute,
        new_attributes: this.initialNewAttribute,
        fromPrice: 0,
        toPrice: this.maxPrice,
        fromYear: this.minYear,
        toYear: this.maxYear,
        isDailyDealToday: this.isDailyDealToday ?? false,
        isRareFind: this.isRareFind ?? false,
        isTap: this.isTap ? "tap" : false,
        sort: this.initialSort,
        perPage: this.initialPerPage,
        page: this.initialPage,
        pickNumber: ""
      }
    }
  },
  computed: {
    emptyProducts() {
      return this.products.data.length === 0
    },

    totalPage() {
      return Math.ceil(this.products.total / this.queryParams.perPage)
    },

    showingResults() {
      if (this.emptyProducts) {
        return
      }

      return trans("storefront::products.showing_results", {
        from: this.products.from,
        to: this.products.to,
        total: this.products.total
      })
    }
  },
  mounted() {
    this.addEventListeners()
    this.initPriceFilter()
    this.initYearFilter()
    this.fetchProducts()
  },
  methods: {
    setActive(filterId) {
      if (this.activeFilters.includes(filterId)) {
        this.activeFilters.filter(item => item !== filterId)
      } else {
        this.activeFilters.push(filterId)
      }
    },
    searchCountry(searchKeyword) {
      this.keyword = searchKeyword
      if (!this.keyword) {
        this.countries = this.attributeFilters.countries
      } else {
        this.countries = this.attributeFilters.countries.filter((country) => country.name.toLowerCase().includes(this.keyword.toLowerCase()))
      }
    },
    addEventListeners() {
      $(this.$refs.sortSelect).on("change", e => {
        this.queryParams.sort = e.currentTarget.value

        this.fetchProducts()
      })

      $(this.$refs.perPageSelect).on("change", e => {
        this.queryParams.perPage = e.currentTarget.value

        this.fetchProducts()
      })
    },

    initPriceFilter() {
      if (!this.$refs.priceRange) return
      noUiSlider.create(this.$refs.priceRange, {
        connect: true,
        direction: window.Trillion.rtl ? "rtl" : "ltr",
        start: [0, this.maxPrice],
        range: {
          min: [0],
          max: [this.maxPrice]
        }
      })

      this.$refs.priceRange.noUiSlider.on("update", (values, handle) => {
        let value = Math.round(values[handle])
        if (handle === 0) {
          this.queryParams.fromPrice = value
        } else {
          this.queryParams.toPrice = value
        }
      })

      this.$refs.priceRange.noUiSlider.on("change", this.fetchProducts)
    },

    initYearFilter() {
      if (!this.$refs.yearRange) return
      noUiSlider.create(this.$refs.yearRange, {
        connect: true,
        direction: window.Trillion.rtl ? "rtl" : "ltr",
        start: [this.minYear, this.maxYear],
        range: {
          min: [this.minYear],
          max: [this.maxYear]
        }
      })

      this.$refs.yearRange.noUiSlider.on("update", (values, handle) => {
        let value = Math.round(values[handle])
        if (handle === 0) {
          this.queryParams.fromYear = value
        } else {
          this.queryParams.toYear = value
        }
      })

      this.$refs.yearRange.noUiSlider.on("change", this.fetchProducts)
    },

    updatePriceRange(fromPrice, toPrice) {
      if (fromPrice)
        this.queryParams.fromPrice = fromPrice
      if (toPrice)
        this.queryParams.toPrice = toPrice
      this.fetchProducts()
    },

    updateYearRange(fromYear, toYear) {
      if (!this.$refs.yearRange) return
      this.$refs.yearRange.noUiSlider.set([fromYear, toYear])

      this.fetchProducts()
    },

    toggleAttributeFilter(slug, value, attribute = "attribute") {
      if (!this.queryParams[attribute].hasOwnProperty(slug)) {
        this.queryParams[attribute][slug] = []
      }

      if (this.queryParams[attribute][slug].includes(value)) {
        this.queryParams[attribute][slug].splice(
          this.queryParams[attribute][slug].indexOf(value),
          1
        )
      } else {
        if (slug == "Pick") {
          this.queryParams.pickNumber = value
        } else {
          this.queryParams[attribute][slug].push(value)
        }
      }
      this.fetchProducts({ updateAttributeFilters: false })
    },

    isFilteredByAttribute(slug, value, attribute = "attribute") {
      if (!this.queryParams[attribute].hasOwnProperty(slug)) {
        return false
      }

      return this.queryParams[attribute][slug].includes(value)
    },

    changeCategory(category) {
      this.categoryName = category.name
      this.categoryBanner = category.banner.path
      this.queryParams.query = null
      this.queryParams.category = category.slug
      this.queryParams.attribute = {}
      this.queryParams.page = 1

      this.fetchProducts()
    },

    changePage(page) {
      this.queryParams.page = page

      this.fetchProducts()
    },

    fetchProducts(options = { updateAttributeFilters: true }) {
      this.fetchingProducts = true

      $.ajax({
        url: route("products.index", this.queryParams)
      })
        .then(response => {
          this.products = response.products
          this.attributeFilters = response.attributes
          this.countries = this.attributeFilters?.countries
        })
        .catch(xhr => {
          this.$errorNotify(xhr.responseJSON.message)
        })
        .always(() => {
          this.fetchingProducts = false
        })
    },

    attributeValue(attribute, value) {
      if (attribute.type == "Yes/No") {
        return value == 1 ? "On" : "Off"
      }
      return value
    },

    removeDailyDealProduct(productId) {
      const index = this.products.data.findIndex(p => p.id == productId)
      if (index !== -1) {
        this.products.data.splice(index, 1)
        if (typeof this.products.total === "number") {
          this.products.total = Math.max(0, this.products.total - 1)
        }
      }
    }
  }
}
